import { Button } from '@/shared/ui/button';

export function SessionExpiredPage() {
  return (
    <main
      aria-labelledby="session-expired-heading"
      className="flex min-h-screen items-center justify-center p-8"
    >
      <section className="flex w-full max-w-120 flex-col items-center gap-4 text-center">
        <h1 id="session-expired-heading" className="text-xl font-semibold">
          Session expired
        </h1>
        <p>Your session has expired. Please log in again to continue — your work is preserved.</p>
        <div className="flex w-full justify-center">
          <Button
            onClick={() => {
              window.location.replace('/api/auth/login');
            }}
          >
            Login again
          </Button>
        </div>
      </section>
    </main>
  );
}
